import allieAvatar from '../assets/pictures/allie_image.png'
import userAvatar from '../assets/pictures/user.png'

export function BotAvatar({ size = 44, className = '' }) {
  return (
    <img
      src={allieAvatar}
      alt="Allie"
      className={`avatar avatar-bot ${className}`}
      style={{ width: size, height: size }}
    />
  )
}

export function UserAvatar({ size = 44, className = '' }) {
  return (
    <img
      src={userAvatar}
      alt="You"
      className={`avatar avatar-user ${className}`}
      style={{ width: size, height: size }}
    />
  )
}
